import { SVGProps, Ref, forwardRef } from 'react';

export const ImageStackOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M8 .5c3.442 0 5.152.242 5.748 1.534a9 9 0 0 0-1.574-.377C11.018 1.479 9.62 1.43 8 1.43s-3.018.049-4.173.227c-.55.084-1.08.203-1.575.377C2.848.742 4.558.5 8 .5"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.95 8.417c-.34.406-.844.617-1.45.617s-1.11-.21-1.45-.617c-.32-.384-.417-.854-.417-1.25s.098-.867.418-1.25c.338-.407.843-.617 1.449-.617s1.11.21 1.45.617c.319.383.417.854.417 1.25s-.098.866-.418 1.25m-1.076-.896c.044-.054.092-.167.092-.354 0-.188-.048-.3-.092-.354-.026-.031-.105-.113-.374-.113-.27 0-.348.082-.374.113-.045.054-.093.166-.093.354s.048.3.093.354c.026.03.105.112.374.112s.348-.081.373-.112"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.641 9.165C-.028 3.622 1.561 2.83 8 2.83s8.028.792 7.359 6.335S13.77 15.5 8 15.5 1.31 14.708.641 9.165m1.39-.168c-.34-2.812.04-3.62.496-3.983.284-.226.786-.445 1.726-.59C5.185 4.28 6.402 4.23 8 4.23s2.815.05 3.747.194c.94.145 1.442.364 1.726.59.457.364.835 1.171.496 3.983-.09.742-.18 1.369-.281 1.902l-2.272-1.645-2.28 1.572-3.412-2.347-3.409 2.435a29 29 0 0 1-.284-1.917m.666 3.365c.196.515.406.8.624.988.26.224.668.426 1.433.561.78.138 1.816.19 3.246.19s2.466-.052 3.246-.19c.765-.135 1.173-.337 1.433-.56.219-.19.431-.478.628-1l-1.91-1.383-2.26 1.557-3.397-2.337z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ImageStackOutlinedSize16Glyph.displayName = 'ImageStackOutlinedSize16Glyph';
